import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ScenarioChatFragment = { __typename?: 'ScenarioChat', guid: string, title: string, messages: Array<{ __typename?: 'ScenarioChatMessage', guid: string, body: string, selectionsV2?: { __typename?: 'ScenarioChatMessageBasicSelections', basicSelections: Array<{ __typename?: 'ScenarioChatMessageBasicSelection', guid: string, label: string, nextMessageIndex?: number | null, actions: Array<{ __typename?: 'ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch', assignedStaffGUID: string }> }> } | { __typename?: 'ScenarioChatMessageBookingRequestSelections', fallbackUrl?: string | null } | null }> };

export type ScenarioChatMesageFragment = { __typename?: 'ScenarioChatMessage', guid: string, body: string, selectionsV2?: { __typename?: 'ScenarioChatMessageBasicSelections', basicSelections: Array<{ __typename?: 'ScenarioChatMessageBasicSelection', guid: string, label: string, nextMessageIndex?: number | null, actions: Array<{ __typename?: 'ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch', assignedStaffGUID: string }> }> } | { __typename?: 'ScenarioChatMessageBookingRequestSelections', fallbackUrl?: string | null } | null };

export type ScenarioChatMessageBasicSelectionFragment = { __typename?: 'ScenarioChatMessageBasicSelection', guid: string, label: string, nextMessageIndex?: number | null, actions: Array<{ __typename?: 'ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch', assignedStaffGUID: string }> };

export type ScenarioChatFormQueryFragment = { __typename?: 'Query', staffsByPlanner: Array<{ __typename?: 'Staff', guid: string, displayName: string }> };

export type ScenarioChatStaffFragment = { __typename?: 'Staff', guid: string, displayName: string };

export const ScenarioChatMessageBasicSelectionFragmentDoc = gql`
    fragment ScenarioChatMessageBasicSelection on ScenarioChatMessageBasicSelection {
  guid
  label
  nextMessageIndex
  actions {
    ... on ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch {
      assignedStaffGUID
    }
  }
}
    `;
export const ScenarioChatMesageFragmentDoc = gql`
    fragment ScenarioChatMesage on ScenarioChatMessage {
  guid
  body
  selectionsV2 {
    ... on ScenarioChatMessageBasicSelections {
      basicSelections {
        ...ScenarioChatMessageBasicSelection
      }
    }
    ... on ScenarioChatMessageBookingRequestSelections {
      fallbackUrl
    }
  }
}
    ${ScenarioChatMessageBasicSelectionFragmentDoc}`;
export const ScenarioChatFragmentDoc = gql`
    fragment ScenarioChat on ScenarioChat {
  guid
  title
  messages {
    ...ScenarioChatMesage
  }
}
    ${ScenarioChatMesageFragmentDoc}`;
export const ScenarioChatStaffFragmentDoc = gql`
    fragment ScenarioChatStaff on Staff {
  guid
  displayName
}
    `;
export const ScenarioChatFormQueryFragmentDoc = gql`
    fragment ScenarioChatFormQuery on Query {
  staffsByPlanner {
    ...ScenarioChatStaff
  }
}
    ${ScenarioChatStaffFragmentDoc}`;